
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import InvoiceApply from './components/invoiceApply.vue';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';
import screenShopModal from './components/screenShopModal.vue';
import InvoiceService from '@/services/invoice.service';
import moment from 'moment';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    'invoice-apply': InvoiceApply,
    'screen-shop-modal': screenShopModal,
  },
})
export default class InvoiceIng extends Vue {
  columns = [
    {
      title: '订单号',
      dataIndex: 'amap_order_id',
      align: 'center',
      width: 240,
    },
    // {
    //   title: '城市',
    //   dataIndex: 'city',
    //   align: 'center',
    //   width: 150,
    // },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      align: 'center',
      width: 240,
    },
    {
      title: '项目名称',
      dataIndex: 'goods_name',
      align: 'center',
      width: 160,
    },
    // {
    //   title: '订单金额',
    //   dataIndex: 'order_price',
    //   align: 'center',
    //   width: 120,
    // },
    // {
    //   title: '总核销次数',
    //   dataIndex: 'tnum',
    //   align: 'center',
    //   width: 120,
    // },
    // {
    //   title: '已核销次数',
    //   dataIndex: 'cnum',
    //   align: 'center',
    //   width: 120,
    // },
    {
      title: '核销金额',
      dataIndex: 'verify_order_price',
      align: 'center',
      width: 120,
    },

    {
      title: '抽拥比例',
      dataIndex: 'com_ratio',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        return text ? `${text * 100}%` : '--';
      },
    },
    {
      title: '抽拥金额',
      dataIndex: 'commission_amount',
      align: 'center',
      width: 120,
    },
  ];

  AuthEnum = AuthEnum;

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Ref('invoiceApply')
  invoiceApply!: InvoiceApply;

  @Ref('screenShopModal')
  screenShopModal!: screenShopModal;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  selectedRowKeys: string[] = [];
  form: any = {
    ka_id: undefined,
    amap_order_id: '',
    shop_id: undefined,
    verify_time_start: '',
    verify_time_end: '',
  };

  shopList: any[] = [];

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    onChange: this.paginationChange,
  };

  data = [
    {
      id: '1',
      province: '增值税专用发票',
    },
  ];

  verify_time: any[] = [];

  kaList: any[] = [];

  rawId = '';

  commissionOrders: any[] = [];

  @Watch('$route')
  onRouteChange() {
    const { ka_id, amap_order_id, shop_id, verify_time_start, verify_time_end, page, pageSize } = this.$route.query;
    const query: any = {
      page,
      pageSize,
    };
    if (ka_id) {
      query.ka_id = ka_id;
      this.form.ka_id = +ka_id;
    } else {
      query.ka_id = this.kaList[0].val;
      this.form.ka_id = this.kaList[0].val;
    }
    if (amap_order_id) {
      query.amap_order_id = amap_order_id;
      this.form.amap_order_id = amap_order_id;
    }
    if (shop_id) {
      query.shop_ids = shop_id;
      this.form.shop_id = shop_id;
    }
    if (verify_time_start && verify_time_end) {
      this.form.verify_time_start = verify_time_start;
      this.form.verify_time_end = verify_time_end;
      this.verify_time = [verify_time_start, verify_time_end];
      query.verify_time_start = verify_time_start;
      query.verify_time_end = verify_time_end;
    }
    // if (verify_time_end) {
    //   const timeEnd: any = verify_time_end;
    //   const currentDate = new Date();
    //   const currentMonth = currentDate.getMonth() + 1;
    //   const currentYear = currentDate.getFullYear();
    //   const verifyTimeEnd = new Date(timeEnd);
    //   const verifyMonth = verifyTimeEnd.getMonth() + 1;
    //   const verifyYear = verifyTimeEnd.getFullYear();
    //   // if (verifyYear > currentYear || (verifyYear === currentYear && verifyMonth >= currentMonth)) {
    //   //   this.$message.warning('结束时间必须小于当前月份');
    //   //   return;
    //   // }
    // }
    // const shopData: any = { ka_id: this.form.ka_id };
    // this.getShopList(shopData);
    this.getOrderList(query);
  }

  selectShop(shop_id: any) {
    this.form.shop_id = shop_id.join(',');
    this.search();
  }

  search() {
    const { ka_id, amap_order_id, shop_id, verify_time_start, verify_time_end } = this.form;
    const { pageSize } = this.pagination;
    const query: any = {
      page: 1,
      pageSize,
    };
    this.pagination.current = 1;
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (amap_order_id) {
      query.amap_order_id = amap_order_id;
    }
    if (shop_id) {
      query.shop_id = shop_id;
    }
    if (verify_time_start) {
      query.verify_time_start = verify_time_start;
    }
    if (verify_time_end) {
      query.verify_time_end = verify_time_end;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }


  onKaChange(val: any) {
    this.form.ka_id = val;
    this.form.shop_id = undefined;
    // this.getShopList({ ka_id: val });
  }

  async getOrderList(query: any) {
    const res = await this.invoiceService.getInvoiceCommissionOrders(query);
    if (res) {
      this.pagination.total = res.total;
      this.commissionOrders = res.list;
      this.rawId = res.max_raw_id;
    } else {
      this.pagination.total = 0;
      this.commissionOrders = [];
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const { ka_id, amap_order_id, shop_id, verify_time_start, verify_time_end } = this.form;
    const query: any = {
      page,
      pageSize,
    };
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (amap_order_id) {
      query.amap_order_id = amap_order_id;
    }
    if (shop_id) {
      query.shop_id = shop_id;
    }
    if (verify_time_start) {
      query.verify_time_start = verify_time_start;
    }
    if (verify_time_end) {
      query.verify_time_end = verify_time_end;
    }
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  handleSubmit() {
    if (this.commissionOrders.length === 0) {
      this.$message.warning('没有可开票的订单');
      return;
    }
    this.invoiceApply.init();
  }

  shopFilter() {
    this.screenShopModal.init(this.form);
  }

  async getShopList(shopData: any) {
    const res = await this.invoiceService.searchShops(shopData);
    this.shopList = res;
  }

  shopFilterOption(input: any, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  onSelectChange(selectedRowKeys: string[]) {
    this.selectedRowKeys = selectedRowKeys;
  }

  refresh() {
    const { pageSize } = this.pagination;
    const query: any = {
      page: 1,
      pageSize,
    };
    this.form = {
      ka_id: this.kaList[0].val,
      amap_order_id: '',
      shop_id: undefined,
      verify_time_start: '',
      verify_time_end: '',
    };
    this.verify_time = [];
    this.pagination.current = 1;
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  handleChange(value: any) {
    this.verify_time = value;
    if (value && value.length) {
      this.form.verify_time_start = moment(value[0]).format('YYYY-MM-DD');
      this.form.verify_time_end = moment(value[1]).format('YYYY-MM-DD');
    } else {
      this.form.verify_time_start = '';
      this.form.verify_time_end = '';
    }
  }

  mounted() {
    this.getKaList();
  }

  async getKaList() {
    const res = await this.spuService.kaSpuAccessibleKas();
    if (res && res.length) {
      this.kaList = [...res];
    }
    this.onRouteChange();
  }
}
